export default "__VITE_ASSET__DsWhRUeU__"